/* eslint-disable react/prop-types */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import OnAir from "../../scenes/OnAir";
import WrapWithProviders from "../ssrWrapper";
var removeQueryParam = function(router, param) {
    var pathname = router.pathname, query = router.query;
    var params = new URLSearchParams(query);
    params.delete(param);
    router.replace({
        pathname: pathname,
        query: params.toString()
    }, undefined, {
        shallow: true
    });
};
var OnAirPage = function(_param) {
    var i18n = _param.i18n, router = _param.router, props = _object_without_properties(_param, [
        "i18n",
        "router"
    ]);
    useEffect(function() {
        if (router.isReady && router.query.token) {
            removeQueryParam(router, "token");
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ _jsx(WrapWithProviders, _object_spread_props(_object_spread({
        i18n: i18n
    }, props), {
        children: /*#__PURE__*/ _jsx(OnAir, _object_spread({}, props))
    }));
};
export default OnAirPage;
